/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Resource } from '../../models/resource';
import { ResourceDto } from '../../models/resource-dto';

export interface ResourceControllerUpdateResource$Params {
  resourceId: string;
      body: ResourceDto
}

export function resourceControllerUpdateResource(http: HttpClient, rootUrl: string, params: ResourceControllerUpdateResource$Params, context?: HttpContext): Observable<StrictHttpResponse<Resource>> {
  const rb = new RequestBuilder(rootUrl, resourceControllerUpdateResource.PATH, 'put');
  if (params) {
    rb.path('resourceId', params.resourceId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Resource>;
    })
  );
}

resourceControllerUpdateResource.PATH = '/resources/{resourceId}';
